import Vue from 'vue'
import Router from 'vue-router'
import utils from '../services/utils.js'

const FormTest = () => import('../views/FormTest')
const AttachConferenceDemo = () => import('../views/AttachConferenceDemo')
const VideoPlayer = () => import('../components/AttachWrapper')

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/conferenceDemo',
      name: 'conference-demo',
      component: AttachConferenceDemo
    },
    {
      path: '/gallery',
      name: 'demo-gallery',
      component: VideoPlayer
    },
    {
      path: '/formtest',
      name: 'form-test',
      component: FormTest
    },
    {
      path: '/player/:env/:id',
      name: 'attach-player',
      component: VideoPlayer
    },
    {
      path: '/convert/:env/:id',
      name: 'attach-convert-player',
      component: VideoPlayer
    },
    {
      path: '/:id',
      name: 'attach-universal-link',
      component: VideoPlayer
    },
    {
      path: '/desktop/player/:env/:id',
      name: 'attach-player-desktop',
      component: VideoPlayer
    }
  ]
})



// WEBPACK FOOTER //
// ./client/router/index.js